import { z } from '../params'

// The input each OAuth SYSTEM method carries. Runtime-owned, not author-declared. LOOSE where the producer
// is the console's OAuth controller: it may send fields a given milestone doesn't model yet, and dropping
// them silently would be worse than carrying them through.

export const OAuthCallbackObjectSchema = z.looseObject({
  code: z.string().optional(),
  redirectURI: z.string().optional(),
  // The PKCE verifier round-trips through `state`.
  state: z.string().optional(),
})

export const RefreshTokenSchema = z.string().min(1)
